// @ts-nocheck
import * as types from '../../mutation-types';
import actions from './actions';

const state = {
  regionResults: [],
  noRegionResults: false,
  postalCodeResults: [],
  listingFound: null,
  noListingFound: false,
};

const mutations = {
  [types.SET_LOCATION_SUGGESTIONS](state, results) {
    resetAllResults(state);
    state.regionResults = results || [];
    state.noRegionResults = state.regionResults.length === 0;
  },

  [types.SET_POSTAL_CODE_SUGGESTIONS](state, results) {
    resetAllResults(state);
    state.noRegionResults = results.length === 0;

    if (!state.noRegionResults) {
      state.postalCodeResults = results;
    }
  },

  [types.RESET_LOCATION_SUGGESTIONS](state) {
    resetAllResults(state);
  },

  [types.FOUND_LISTING](state, listing) {
    resetAllResults(state);
    state.listingFound = listing.id;
  },

  [types.NO_LISTING_FOUND](state) {
    resetAllResults(state);
    state.noListingFound = true;
  },
};

const resetAllResults = (state) => {
  state.regionResults = [];
  state.noRegionResults = false;
  state.postalCodeResults = [];
  state.listingFound = null;
  state.noListingFound = false;
};

const getters = {
  regionResults: (state) => state.regionResults,
  postalCodeResults: (state) => state.postalCodeResults,
  noRegionResults: (state) => state.noRegionResults,
  listingFound: (state) => state.listingFound,
  noListingFound: (state) => state.noListingFound,
};

export default {
  state,
  getters,
  mutations,
  actions,
};
